module.exports = __webpack_public_path__ + "static/media/medicine.622bba7a.svg";